import get from 'lodash/get';
import { isSimpleDeviation } from '../DeviationViews/_helpers';
export default function useDeviationStats(deviation) {
    var isComplexType = !isSimpleDeviation(deviation);
    return {
        faves: get(deviation, 'stats.favourites', 0),
        isFavouritable: isComplexType,
        comments: get(deviation, 'stats.comments', 0),
        isCommentable: deviation.isCommentable,
        views: get(deviation, 'extended.stats.views', 0),
        viewsToday: get(deviation, 'extended.stats.today', 0),
        isViewCountable: isComplexType,
        // TODO: hardcoded until we can get data from backend
        subscribers: 30,
        isSubscribable: true,
        hasTooltips: isComplexType,
    };
}
//# sourceMappingURL=useDeviationStats.js.map